module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_2257", [["div",{"class":"pad-lr pad-tb"},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"2257Title","data-fox-context":"2257"},[["textNode",{"text":"CUSTODIAN OF RECORDS U.S.C. TITLE 18, SECTION 2257 COMPLIANCE"}]]]]],["div",{"class":"static-page-docs"}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/2257.tpl
// module id = 1186
// module chunks = 4